import React, { useEffect } from 'react';
import axios from 'axios';
import API_URL from '../config/api';

const About = () => {
  useEffect(() => {
    // Track page view
    axios.post(`${API_URL}/api/track`, { page: 'about', action: 'page_view' }).catch(() => {});
  }, []);

  return (
    <div className="bg-[#f8f3e8] min-h-screen py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero Section */}
        <div className="text-center mb-4">
          <h1 className="text-4xl font-bold mb-4 text-[#1f3a27]" style={{ fontFamily: 'Georgia, serif' }}>About Us</h1>
          </div>
        <div className="max-w-4xl mx-auto space-y-5 text-gray-700 mb-12">
          <p className="text-lg leading-relaxed text-justify">
            At Earthly Spice Exports, we are committed to delivering the finest quality spices sourced directly from trusted farms. Our focus is on purity, consistency, and global standards, ensuring every product meets the expectations of international buyers.
          </p>
          <p className="text-lg leading-relaxed text-justify">
            With a strong foundation in sourcing and quality control, we carefully select, process, and package our spices to retain their natural aroma, flavor, and nutritional value. Our streamlined supply chain allows us to serve bulk buyers, wholesalers, and private label clients efficiently.
          </p>
          <p className="text-lg leading-relaxed text-justify">
            We believe in building long-term partnerships by offering reliable service, transparent communication, and competitive pricing.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-[#fffdf8] rounded-2xl border border-[#e7decb] shadow-lg p-8">
            <h2 className="text-2xl font-bold mb-4 text-[#1f3a27]" style={{ fontFamily: 'Georgia, serif' }}>Our Mission</h2>
            <p className="text-gray-700 leading-relaxed text-justify">
              To supply premium quality spices globally with trust, consistency, and excellence.
            </p>
          </div>

          <div className="bg-[#fffdf8] rounded-2xl border border-[#e7decb] shadow-lg p-8">
            <h2 className="text-2xl font-bold mb-4 text-[#1f3a27]" style={{ fontFamily: 'Georgia, serif' }}>Our Vision</h2>
            <p className="text-gray-700 leading-relaxed text-justify">
              To become a preferred export partner for high-quality spices worldwide.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
